import { render, staticRenderFns } from "./px-expand.vue?vue&type=template&id=fcc1f930&"
import script from "./px-expand.vue?vue&type=script&lang=ts&"
export * from "./px-expand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports